import { render, staticRenderFns } from "./sk-line-wap.vue?vue&type=template&id=05335ffe&"
import script from "./sk-line-wap.vue?vue&type=script&lang=js&"
export * from "./sk-line-wap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports